<template>
  <v-card min-width="100%">
    <!-- <v-row justify="center">
      <v-col cols="3" xs="12"><span class="px-2 font-weight-bold red--text">Monto Total:</span> {{ pago_total }} bs.</v-col>
      <v-col cols="3" xs="12"><span class="px-2 font-weight-bold">Por Recibo:</span> {{ pago_recibo }} bs.</v-col>
      <v-col cols="3" xs="12"><span class="px-2 font-weight-bold">Regularizado:</span> {{ monto_regularizado }} bs.</v-col>
      <v-col cols="2" xs="12"><span class="px-2 font-weight-bold red--text">Saldo:</span> {{ saldo_total }} bs.</v-col>
      <v-tooltip bottom>
        <template #activator="{ on, attrs }">
          <v-icon v-on="on" v-bind="attrs" @click="showMoreDetails">mdi-eye</v-icon>
        </template>
        Mas detalle
      </v-tooltip>
    </v-row> -->
    <plan-pagos-details ref="refPlaPagosDetail" />
  </v-card>
</template>

<script>
  import xaxios from '@/xaxios';
  import PlanPagosDetails from './PlanPagosDetails';

  export default {
    components: { PlanPagosDetails },
    props: { inscripcion_id: { type: Number, default: 0 } },
    data() {
      return {
        menu_name: process.env.VUE_APP_NAME_MENU,
        api_rest: process.env.VUE_APP_API_REST,

        xinscripcion_id: '',
        pago_total: 0,
        saldo_total: 0,
        monto_regularizado: 0,
        pago_recibo: 0,
        plan_pagos: [],
      };
    },
    methods: {
      calculate_pagos_saldos(id) {
        this.xinscripcion_id = id;
        const url = `${this.api_rest}/api/v1/inscripcion/${id}/plan-pago`;
        xaxios.get(url).then(({ data }) => {
          // window.console.log(data);
          this.plan_pagos = data.data;
        });
      },
      showMoreDetails() {
        this.$refs.refPlaPagosDetail.showThisView(this.plan_pagos, null, this.xinscripcion_id);
      },
    },
    mounted() {
      this.calculate_pagos_saldos(this.inscripcion_id);
    },
    destroyed() {
      this.plan_pagos = [];
      this.pago_total = 0;
      this.saldo_total = 0;
      this.monto_regularizado = 0;
      this.pago_recibo = 0;
    },
  };
</script>
